module.exports = __webpack_public_path__ + "static/media/temp_37.aae4c510.jpg";